import React from "react";

// @material-ui/core
// core components
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import SystemLogsTable from "components/Table/SystemLogsTable";
import { Box } from '@mui/material';
import { ToastContainer } from "react-toastify";

export default function SystemLogs() {
  return (
    <div>
      <ToastContainer/>
      
      <Grid container spacing={3}>
        <Grid item xs={12} md={12} lg={12}>
          <MDBox>
            <Box sx={{ width: '100%' }}>
              <SystemLogsTable />
            </Box>
          </MDBox>
        </Grid>
      </Grid>
    </div>
  );
}


function BasicTabs() {
  return (
    <Box sx={{ width: '100%' }}>
      <SystemLogsTable />
    </Box>
  );
}